import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// import Swiper core and required modules
import SwiperCore, { Pagination, Autoplay } from "swiper";

import SuccessSlide from "./SuccessSlide";
// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "./SuccessSlider.scss";

// install Swiper modules
SwiperCore.use([Pagination]);
SwiperCore.use([Autoplay]);

export default function SuccessSlider() {
	return (
		<div className="success-slider-container">
			<Swiper
				pagination={true}
				slidesPerView={1}
				className="success-swiper"
				autoplay={{ delay: 3500 }}
				loop={true}
			>
				<SwiperSlide>
					<SuccessSlide
						name="John"
						imgURL="https://placedog.net/299/402?random/"
						dateMatched="November 2021"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<SuccessSlide
						name="Paul"
						imgURL="https://placedog.net/299/401?random/"
						dateMatched="Septemeber 2021"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<SuccessSlide
						name="George"
						imgURL="https://placedog.net/300/401?random/"
						dateMatched="July 2021"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<SuccessSlide
						name="Ringo"
						imgURL="https://placedog.net/299/400?random/"
						dateMatched="June 2021"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<SuccessSlide
						name="Prince"
						imgURL="https://placedog.net/300/400?random/"
						dateMatched="May 2021"
					/>
				</SwiperSlide>

				<SwiperSlide>
					<SuccessSlide
						name="Penny"
						imgURL="https://placedog.net/299/401?random/"
						dateMatched="March 2021"
					/>
				</SwiperSlide>
			</Swiper>
		</div>
	);
}
